//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


export default {
	name: 'loadmore',
	props: {
        count: {
            default:0,
            type:Number,
        },
        emptyText: {
            default: '什么也没有!',
            type: String,
        },
        emptyImg: {
            default: '/static/img/empty.png',
            type: String,
        },
        onlyText: {
            default: false,
            type: Boolean,
        }
    },
    data(){
        return {
            default: 0,
            showBottom: false,
        }
    },
    methods: {
        change(item,index){

            this.tabData.forEach(res=>{
                res.active = '';
            })
            this.tabData[index].active = true;
            this.$emit("on-change",item,index);
        },

        // 监听滚动事件
        listenerScroll(){
            // console.log(1);
            // window.onscroll=function(){
            //     console.log(document.documentElement.scrollTop)
            //     console.log(11);
            // }
        },
    },
    mounted(){
        this.listenerScroll();
    }
}



// WEBPACK FOOTER //
// ./src/components/ui/loadmore.vue